import { useTranslation } from 'react-i18next'
import IndicatorDashboardResultsComponent from '../indicatorDashboardResultsComponent'
import NetworkComponent from '../networkComponent'
import WorkgroupDashboardContainer from '../workgroupDashboardContainer'
import BupSpinner from '@BUP/components/Loading/Spinner'

const ResultsComponent = ({ surveyId, loading, result, preAnalyticData }) => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })

  if (!result) return null
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 200
        }}
      >
        <BupSpinner
          size='large'
          tip={t('spinnerText')}
        />
      </div>
    )
  }
  const dataGroups = result.newGroups.groups

  const courseId = parseInt(result.courseId, 10)

  return (
    <div className='results-container'>
      <IndicatorDashboardResultsComponent
        preAnalyticData={preAnalyticData}
        courseId={courseId}
      />
      <NetworkComponent
        preAnalyticData={preAnalyticData}
        courseId={courseId}
        surveyId={surveyId}
      />
      <WorkgroupDashboardContainer dataGroups={dataGroups} />
    </div>
  )
}

export default ResultsComponent
